+function ($) {
    'use strict';

    var formValidator = function (element, options) {
        this.form = $(element);

        this.inputs = this.form.find('input');
        this.texareas = this.form.find('textarea');
        this.selects = this.form.find('select');

        if (options) {
            if (options.callback && typeof(options.callback) === 'function') {
                this.callback = options.callback;
            }
        }
        
        this.inputs.bind('focus', function () {
            $(this).removeClass('has-error');
            $(this).removeAttr('data-tooltip-msg');
        });

        this.texareas.bind('focus', function () {
            $(this).removeClass('has-error');
            $(this).removeAttr('data-tooltip-msg');
        });



        var self = this;
        this.form.bind('submit', function () {
            var submit = true;
            
            if (!self.checkInputs()) {
                submit = false;
            }

            if (!self.checkTexareas()) {
                submit = false;
            }

            if (!self.checkSelects()) {
                submit = false;
            }

            if (!submit) {
                $('[data-tooltip-msg]').ToolTip();
            }

            if (submit) {
                self.form.trigger('form_complete');
                if (self.callback && typeof (self.callback) == 'function') {
                    self.callback();
                    return false;
                }
            }

            return submit;
        });
    };

    formValidator.prototype.checkInputs = function () {
        var checked = true;
        for (var i = 0; i < this.inputs.length; i++) {
            //Узнаем тип инпутов и исходя из этих типов делаем соответствующие проверки
            switch (this.inputs.eq(i).attr('type')) {
                case 'file':
                    var maxSizeFile = this.inputs.eq(i).data('max-size-mb');
                    var maxFiles = this.inputs.eq(i).data('max-file');
                    var accept = this.inputs.eq(i).attr('accept');
                    if (this.inputs.eq(i).data('required') == 'required') {
                        this.inputs.eq(i).addClass("has-error");
                        this.inputs.eq(i).attr('data-tooltip-msg', 'Поле обязательно для заполнения');
                        checked = false;
                        break;
                    }

                    //Проверим файлы на соответствие максимальному размеру
                    if (maxSizeFile) {
                        console.log(this.inputs.eq(i));
                        for (var j = 0; j < this.inputs.eq(i)[0].files.length; j++) {
                            if (this.inputs.eq(i)[0].files[j].size > maxSizeFile*1024*1024) {
                                this.inputs.eq(i).addClass("has-error");
                                this.inputs.eq(i).attr('data-tooltip-msg', 'Размер файла не должен превышать '+maxSizeFile+' Мб');
                                checked = false;
                                break;
                            }
                        }
                    }

                    if (maxFiles) {
                        if (this.inputs.eq(i)[0].files.length > maxFiles) {
                            this.inputs.eq(i).addClass("has-error");
                            this.inputs.eq(i).attr('data-tooltip-msg', 'Количество файлов не должно превышать '+maxFiles+' шт.');
                            checked = false;
                            break;
                        }
                    }

                    /*
                    if (accept) {
                        for (var j = 0; j < this.inputs.eq(i).files.length; j++) {
                            if (this.inputs.eq(i).files[j].type.match(accept)) {
                                checked = false;
                                this.inputs.eq(i).addClass("has-error");
                                this.inputs.eq(i).attr('data-tooltip-msg', 'Файлы могут быть только '+accept+' типов');
                            }
                        }
                    }*/
                    break;
                default:
                    if (this.inputs.eq(i).data('required') == 'required') {
                        if (this.inputs.eq(i).val() == '') {
                            this.inputs.eq(i).addClass("has-error");
                            this.inputs.eq(i).attr('data-tooltip-msg', 'Поле обязательно для заполнения');
                            checked = false;
                        }
                    }
                    break;
            }
        }

        return checked;
    };

    formValidator.prototype.checkTexareas = function () {
        var checked = true;
        for (var i = 0; i < this.texareas.length; i++) {
            if (this.texareas.eq(i).data('required') == 'required') {
                if (this.texareas.eq(i).val() == '') {
                    this.texareas.eq(i).addClass("has-error");
                    this.texareas.eq(i).attr('data-tooltip-msg', 'Поле обязательно для заполнения');
                    checked = false;
                }
            }
        }

        return checked;
    };

    formValidator.prototype.checkSelects = function () {
        var checked = true;
        for (var i = 0; i < this.selects.length; i++) {
            if (this.selects.eq(i).data('required') == 'required') {
                if (this.selects.eq(i).val() == '') {
                    this.selects.eq(i).addClass("has-error");
                    this.selects.eq(i).attr('data-tooltip-msg', 'Поле обязательно для заполнения');
                    checked = false;
                }
            }
        }

        return checked;
    };

    var constructor = function (options) {
        //вернуть надо объект jQuery
        return this.each(function () {
            new formValidator(this, options);
        });
    };



    var old = $.fn.formValidator;

    $.fn.formValidator = constructor;
    $.fn.formValidator.constructor = constructor;

    $.fn.formValidator.noConflict = function () {
        $.fn.formValidator = old;
        return this;
    }
}(jQuery);